import React from 'react';
import '../Project/project.css'

export default function Project() {
  return (
      <><section className='content'>
      <h1 className='d-flex justify-content-center'>My Projects</h1>
      

<section className="wrapper">
  <div className="container">
  
  <div className="row">
 <div className="col-md-12"><div className="card text-white card-has-bg click-col img1 back">
         <img className="card-img d-none" src="https://source.unsplash.com/600x900/?tech" alt="Goverment Lorem Ipsum Sit Amet Consectetur dipisi?"/>
        <div className="card-img-overlay d-flex flex-column">
         <div className="card-body">
            <small className="card-meta mb-2">Project 1</small>
            <h4 className="card-title mt-0 ">My Portfolio Website</h4>
           <small> February 10, 2022</small>
           <p className='my-5'>Visit: <a href="https://avanishcp.000webhostapp.com/" className='text-danger' target={'_blank'} rel='noreferrer'>avanishcp.com</a></p>
           <p>Technologies Used: <strong> HTML, CSS, javascript, Bootstrap </strong></p>
           

          </div> 
          
        </div>
      </div></div>


      <div className="col-md-12 my-3"><div className="card text-white card-has-bg click-col img1  back">
         <img className="card-img d-none" src="https://source.unsplash.com/600x900/?tech" alt="Goverment Lorem Ipsum Sit Amet Consectetur dipisi?"/>
        <div className="card-img-overlay d-flex flex-column">
         <div className="card-body">
            <small className="card-meta mb-2">Project 2</small>
            <h4 className="card-title mt-0 ">Your Kavach Website</h4>
           <small><i className="far fa-clock"></i> November 5, 2021</small>
           <p className='my-5'>Visit: <a href="http://www.yourkavach.com/" className='text-danger' target={'_blank'} rel='noreferrer'>www.yourkavach.com</a></p>
           <p>Technologies Used: <strong> HTML, CSS, javascript, Bootstrap </strong></p>
          </div>
        </div>
      </div></div>
      
        
</div>

<p>More project will be updated soon...</p>
  
</div>
</section>


  


</section>      </>
  );
}
